import script from "./AnimatedList.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatedList.vue?vue&type=script&setup=true&lang=js"

import "./AnimatedList.vue?vue&type=style&index=0&id=3135ec02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3135ec02"]])

export default __exports__